import React, { useState } from "react";

const Footer = () => {
  const [modalContent, setModalContent] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (content) => {
    setModalContent(content);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalContent("");
    document.body.style.overflow = "auto";
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };
  const modalData = {
    privacyPolicy: (
      <div className="space-y-2 py-2">
        <h2 className="font-bold">{"Privacy Policy"}</h2>
        <p>{"Effective Date: March 4, 2025"}</p>
        <h3 className="font-bold">{"1. Introduction"}</h3>
        <p>
         {" This Privacy Policy outlines how Herbal Tea Therapy "}("we," "our," or "us")  {"collects, uses, and protects your personal information when you visit our website or purchase our products."}
        </p>
        <h3 className="font-bold">{"2. Information We Collect"}</h3>
        <ul className="list-disc list-inside ml-5">
          <li>
            <strong>{"Device Information:"}</strong>
            {
              " We automatically collect details such as your web browser, IP address, time zone, and cookies installed on your device."
            }
          </li>
          <li>
            <strong>{"Order Information:"}</strong>
            {
              " When you make a purchase, we gather your name, billing and shipping addresses, payment details, email address, and phone number."
            }
          </li>
        </ul>
        <h3 className="font-bold">{"3. How We Use Your Information"}</h3>
        <ul className="list-disc list-inside ml-5">
          <li>
            <strong>{"Order Fulfillment:"}</strong>
            {
              " To process your orders, handle payments, arrange shipping, and provide order confirmations."
            }
          </li>
          <li>
            <strong>{"Communication:"}</strong>{" "}
            {
              "To contact you regarding your order or to share promotional offers, in line with your preferences."
            }
          </li>
          <li>
            <strong>{"Site Improvement:"}</strong>{" "}
            {
              "To analyze interactions with our site and enhance user experience."
            }
          </li>
        </ul>
        <h3 className="font-bold">{"4. Sharing Your Information"}</h3>
        <p>
          {
            "We may share your information with third parties to assist in using your personal information, as described above. For example, we use Shopify to power our online store."
          }
        </p>
        <h3 className="font-bold">{"5. Data Retention"}</h3>
        <p>
          {
            "We retain your information for our records unless you request its deletion."
          }
        </p>
        <h3 className="font-bold">{"6. Your Rights"}</h3>
        <p>
          {
            "Depending on your jurisdiction, you may have rights regarding your personal data, including access, correction, or deletion. Please contact us to exercise these rights."
          }
        </p>
        <h3 className="font-bold">{"7. Changes to This Policy"}</h3>
        <p>
          {
            "We may update this Privacy Policy periodically. Changes will be posted on this page with an updated effective date."
          }
        </p>
        <h3 className="font-bold">{"8. Contact Us"}</h3>
        <p>
          {
            "For questions or concerns about our privacy practices, please contact us at"
          }{" "}
           <a  href="mailto:support@herbalteatherapy.com" className="hover:underline hover:text-blue-600 font-bold">
            {"support@herbalteatherapy.com"}
          </a>
          .
        </p>
      </div>
    ),
    termsConditions: (
      <div className="space-y-2">
        <h2 className="font-bold">{"Terms and Conditions"}</h2>
        <p>{"Effective Date: March 4, 2025"}</p>
        <h3 className="font-bold">{"1. Acceptance of Terms"}</h3>
        <p>
          {
            "By accessing our website or purchasing our products, you agree to these Terms and Conditions."
          }
        </p>
        <h3 className="font-bold">{"2. Product Use"}</h3>
        <p>
          {
            "Our products are intended for educational and informational purposes only and are not a substitute for professional medical advice. Consult a healthcare professional before use."
          }
        </p>
        <h3 className="font-bold">{"3. Orders and Payments"}</h3>
        <p>
          {
            "All orders are subject to acceptance and availability. We reserve the right to refuse or cancel orders at our discretion. Payments must be made at the time of order."
          }
        </p>
        <h3 className="font-bold">{"4. Shipping and Delivery"}</h3>
        <p>
          {
            "We aim to process and ship orders promptly. Delivery times may vary based on location and shipping method."
          }
        </p>
        <h3 className="font-bold">{"5. Returns and Refunds"}</h3>
        <p>
          {
            "Due to the nature of our products, we do not accept returns or offer refunds unless the product is defective or damaged upon arrival. Contact us within 14 days of receipt for assistance."
          }
        </p>
        <h3 className="font-bold">{"6. Limitation of Liability"}</h3>
        <p>
          {
            "We are not liable for any indirect, incidental, or consequential damages arising from the use of our products or website."
          }
        </p>
        <h3 className="font-bold">{"7. Governing Law"}</h3>
        <p>
          {
            "These terms are governed by the laws of the jurisdiction in which our company is established, without regard to conflict of law principles."
          }
        </p>
        <h3 className="font-bold">{"8. Changes to Terms"}</h3>
        <p>
          {
            "We may update these Terms and Conditions periodically. Changes will be posted on this page with an updated effective date."
          }
        </p>
        <h3 className="font-bold">{"9. Contact Us"}</h3>
        <p>
          {
            "For questions about these Terms and Conditions, please contact us at"
          }{" "}
          <a  href="mailto:support@herbalteatherapy.com" className="hover:underline hover:text-blue-600 font-bold">
            {"support@herbalteatherapy.com"}
          </a>
          .
        </p>
      </div>
    ),
    disclaimer: (
      <div className="space-y-4">
        <h2 className="font-bold">{"Disclaimer"}</h2>
        <p>
          {
            "This website is an advertorial and not an actual article, blog, or consumer protection update. The information provided on this site is not intended to replace professional medical advice, diagnosis, or treatment."
          }
        </p>
        <p>
          {
            "Visitors should always seek the guidance of their personal physician or a qualified healthcare provider with any questions regarding medical conditions or treatments. The author and website owner are not responsible for any misinterpretation or misuse of the information provided, nor for any loss, damage, or injury resulting from the use of any recommendations, treatments, or food sources mentioned on this site."
          }
        </p>
        <p>
          {
            "The U.S. Food and Drug Administration has not reviewed the statements made on this website. All trademarks are the property of their respective owners."
          }
        </p>
        <p>
          {
            "While we strive to keep the content up to date, rules and regulations may change frequently, and we cannot be held liable for any inaccuracies. Thank you for visiting."
          }
        </p>
      </div>
    ),
  };

  return (
    <section className="border-t border-black my-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="section_row text-gray-800">
          <div className="w-full">
            <div className="element-wrapper">
              <div className="paragraph text-gray-400 text-center mx-5 my-5 p-2 space-y-4">
                <p className="text-center italic">
                  {
                    "The information and other content provided on this page, or in any linked materials, are not intended and should not be construed as medical advice, nor is the information a substitute for professional medical expertise or treatment."
                  }
                </p>
                <p className="text-center italic">
                  {
                    "If you or any other person has a medical concern, you should consult with your health care provider or seek other professional medical treatment. Never disregard professional medical advice or delay in seeking it because of something that you have read on this page or in any linked materials. If you think you may have a medical emergency, call your doctor or emergency services immediately."
                  }
                </p>
              </div>
            </div>
            <div>
              <div className="text-gray-400 text-center space-y-4">
                <ul className="flex flex-row md:flex-row justify-center space-x-4 md:space-y-0 items-center">
                  <li>
                    <a
                      className="hover:text-blue-600"
                      onClick={() => openModal(modalData.privacyPolicy)}
                    >
                      <span className="cursor-pointer">{"Privacy Policy"}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="hover:text-blue-600"
                      onClick={() => openModal(modalData.termsConditions)}
                    >
                      <span className="cursor-pointer">
                        {"Terms of Service"}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="hover:text-blue-600"
                      onClick={() => openModal(modalData.disclaimer)}
                    >
                      <span className="cursor-pointer">{"Disclaimer"}</span>
                    </a>
                  </li>
                </ul>
                <ul className="flex justify-center space-x-4">
                  <li>
                    <a className="hover:text-blue-600">
                      <span>{"© 2025 All Rights Reserved."}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="element-wrapper">
              <div className="img my-3">
                <img
                  src="//img.funnelish.com/3383/56407/1673343903-footer.webp"
                  alt=""
                  className="w-full h-auto object-scale-down"
                  style={{ height: "30px" }}
                  draggable="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 py-4 px-3  "
          onClick={handleOverlayClick}
        >
          <div className="bg-white p-5 max-w-7xl mx-auto rounded shadow-lg relative overflow-auto max-h-full">
            <button
              onClick={closeModal}
              className="absolute top-2 right-4 text-gray-500 hover:text-gray-700 h-6 w-6 text-3xl"
              aria-label="Close"
            >
              &times;
            </button>
            <div className="overflow-y-auto max-h-full">{modalContent}</div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Footer;
